export const brandFieldLabelClass = "grid gap-2";

export const brandFieldTitleClass = "text-sm font-semibold tracking-wide text-brand-primary";

export const brandFieldHelperClass = "text-xs text-slate-500";

export const brandFieldErrorClass = "text-xs font-medium text-rose-600";

export const brandFormCardClass =
  "rounded-[2rem] border border-white/20 bg-white/95 p-5 shadow-soft backdrop-blur sm:p-8";

export const brandInputClass =
  "w-full rounded-2xl border border-brand-secondary/65 bg-white/95 px-4 py-3.5 text-brand-primary outline-none transition placeholder:text-slate-400 focus:border-brand-secondary focus:ring-4 focus:ring-brand-accent-light/25 disabled:bg-slate-100 disabled:text-slate-400";

export const brandSelectClass =
  "w-full rounded-2xl border border-brand-secondary/65 bg-white/95 px-4 py-3.5 text-brand-primary outline-none transition focus:border-brand-secondary focus:ring-4 focus:ring-brand-accent-light/25 disabled:bg-slate-100 disabled:text-slate-400";

export const brandInlineActionClass =
  "absolute inset-y-0 right-3 my-auto rounded-full px-3 py-1 text-xs font-semibold text-brand-primary transition-colors hover:bg-brand-primary/10";
